/**
 * theme.js - Main theme JavaScript
 * Event delegation, cart drawer control, gallery navigation
 * Uses IIFEs + CustomEvents, no globals
 */
(function() {
  'use strict';

  function initQuantityInputs() {
    document.addEventListener('click', function(e) {
      const minusBtn = e.target.closest('[data-qty-minus]');
      const plusBtn = e.target.closest('[data-qty-plus]');
      
      if (minusBtn) {
        e.preventDefault();
        const container = minusBtn.closest('.qty-input');
        const input = container ? container.querySelector('input[type="number"]') : null;
        if (input) {
          const currentVal = parseInt(input.value, 10) || 1;
          const minVal = parseInt(input.min, 10) || 1;
          if (currentVal > minVal) {
            input.value = currentVal - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      
      if (plusBtn) {
        e.preventDefault();
        const container = plusBtn.closest('.qty-input');
        const input = container ? container.querySelector('input[type="number"]') : null;
        if (input) {
          const currentVal = parseInt(input.value, 10) || 1;
          const maxVal = input.max ? parseInt(input.max, 10) : Infinity;
          if (currentVal < maxVal) {
            input.value = currentVal + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
  }

  function initGallery() {
    document.addEventListener('click', function(e) {
      const thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      
      e.preventDefault();
      
      const gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      
      const index = parseInt(thumb.dataset.index, 10);
      const scrollContainer = gallery.querySelector('[data-gallery-scroll]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      
      if (scrollContainer) {
        const slideWidth = scrollContainer.offsetWidth;
        scrollContainer.scrollTo({
          left: index * slideWidth,
          behavior: 'smooth'
        });
      }
      
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === index);
      });
    });

    document.querySelectorAll('[data-gallery-scroll]').forEach(function(scrollContainer) {
      let scrollTimeout;
      
      scrollContainer.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          const gallery = scrollContainer.closest('[data-product-gallery]');
          if (!gallery) return;
          
          const slideWidth = scrollContainer.offsetWidth;
          const scrollLeft = scrollContainer.scrollLeft;
          const activeIndex = Math.round(scrollLeft / slideWidth);
          
          const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
          thumbs.forEach(function(t, i) {
            t.classList.toggle('is-active', i === activeIndex);
          });
        }, 50);
      }, { passive: true });
    });
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      
      const href = anchor.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('menu-open');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }

    // Open/close menu
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-menu-open]')) {
        e.preventDefault();
        openMenu();
      }
      if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-overlay]')) {
        e.preventDefault();
        closeMenu();
      }
    });

    // Expandable nav items
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-nav-toggle]');
      if (!toggle) return;
      
      e.preventDefault();
      var parent = toggle.closest('[data-nav-parent]');
      if (!parent) return;
      
      var children = parent.querySelector('[data-nav-children]');
      if (!children) return;
      
      var isOpen = toggle.classList.contains('is-open');
      
      // Close all other open items
      document.querySelectorAll('[data-nav-toggle].is-open').forEach(function(openToggle) {
        if (openToggle !== toggle) {
          openToggle.classList.remove('is-open');
          var openChildren = openToggle.closest('[data-nav-parent]').querySelector('[data-nav-children]');
          if (openChildren) openChildren.hidden = true;
        }
      });
      
      toggle.classList.toggle('is-open', !isOpen);
      children.hidden = isOpen;
    });

    // Bestsellers slider navigation
    var slider = document.querySelector('[data-bestsellers-slider]');
    var prevBtn = document.querySelector('[data-bestsellers-prev]');
    var nextBtn = document.querySelector('[data-bestsellers-next]');
    
    if (slider && prevBtn && nextBtn) {
      var scrollAmount = 160;
      
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    // Close menu on escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Close menu when clicking a link
    menu.addEventListener('click', function(e) {
      if (e.target.closest('a:not([data-nav-toggle])')) {
        closeMenu();
      }
    });
  }

  function init() {
    initQuantityInputs();
    initGallery();
    initSmoothScroll();
    initMobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
